import { FeatureToggleEnum } from '@mwe/constants';
import { boolean, enum as v_enum, InferInput, isoTimestamp, minLength, object, optional, pipe, record, string, union } from 'valibot';

const startEndSchema = optional(
  union([pipe(string(), minLength(1, "Date can't be an empty string")), pipe(string(), isoTimestamp('The timestamp is badly formatted.'))]),
);

export const FeatureToggleSchema = object({
  start: startEndSchema,
  end: startEndSchema,
  defaultValue: boolean(),
});

export const FeatureTogglesSchema = record(v_enum(FeatureToggleEnum), FeatureToggleSchema);

export const FeatureToggleResponseSchema = object({
  'feature-toggles': FeatureTogglesSchema,
});

export type FeatureToggle = InferInput<typeof FeatureToggleSchema>;
export type FeatureToggles = InferInput<typeof FeatureTogglesSchema>;
export type FeatureToggleResponse = InferInput<typeof FeatureToggleResponseSchema>;
